import { isObject } from './type';

/**
 * param参数转化为Object
 * 比如"a=1&b=2"转换成{a:1,b:2}
 * @param params
 */
export function paramsToObject(params) {
    if (!params) return {};
    if (isObject(params)) return params;
    let obj = {};
    let paramsArr = params.split('&');
    let param;
    paramsArr.forEach(item => {
        param = item.split('=');
        obj[param[0]] = param[1] || '';
    });
    return obj;
}

/**
 * 把object转换成get请求的参数
 * 比如{a:1,b:2}转换成"a=1&b=2"
 * @param obj
 * @param shouldCheckuestionMark 是否要加问号
 */
export function objectToGetParams(obj, shouldCheckuestionMark = true) {
    if (!isObject(obj)) return '';
    const str = Object.keys(obj).map(key => {
        return `${key}=${obj[key]}`
    }).join('&');
    return shouldCheckuestionMark ? `?${str}` : str;
}

let isWindowLoaded = false;
const imgReportCache = [];

//为了避免上报卡住微信的绿条加载，会导致jsapi无法调用
window.addEventListener('load', () => {
    setTimeout(() => {
        isWindowLoaded = true;
        imgReportCache.forEach(url => {
            new Image().src = url;
        });
    }, 2000);
});

/**
 * 用于数据上报
 * @param url
 */
export function imgReport(url) {
    if (!url) {
        return;
    }
    if (isWindowLoaded) {
        let Image = window.Image
        new Image().src = url;
    } else {
        imgReportCache.push(url);
    }
}

/**
 * 让数据上报立即生效
 * @param url
 */
export function setReportReady() {
    isWindowLoaded = true;
}

/**
 * 对于模板直出情况，用户后退时会加载旧数据，这里可以强制让他刷新
 * @param callback
 */
export function checkPageShow(callback) {
    callback = callback || function () {
        location.reload()
    };
    // 让用户在返回时强制刷新页面
    window.onpageshow = function (event) {
        if (
            event.persisted ||
            (window.performance && window.performance.navigation.type == 2)
        ) {
            callback();
        }
    };
}

/**
 * 修改标题
 * @param {*} title
 */
export function changeTitle(title) {
    document.title = title;
    var iframe = document.createElement('iframe');
    var iframeCallback = function () {
        setTimeout(function () {
            iframe.removeEventListener('load',
                iframeCallback)
            document.body.removeChild(iframe)
        }, 0)
    }
    iframe.style.visibility = 'hidden'
    iframe.src = location.protocol + '//' + location.hostname +
        '/favicon.ico';
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
}

/**
 * 用户重定向
 * @param url
 * @param time
 */
export function redirect(url, time = 300) {
    setTimeout(() => {
        location.href = url;
    }, 300);
}

export const to = (p) => p.then(data => [null, data]).catch(err => [err, null]);

/**
 * setTimeout的promise实现
 * @param {*} mills 
 */
export function sleep(mills = 100) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, mills);
    });
}

/**
 *  去抖动
 *
 * @export
 * @param {*} expression 函数表达式 返回Boolean
 * @param {*} currentTime 当前执行次数
 * @param {*} maxTime 最大执行次数
 * @param {*} callback 成功返回
 * @param {*} errCallback 失败返回
 * @returns
 */
export function debounce(expression, currentTime, maxTime, callback, errCallback) {
    if (expression()) {
        return callback && callback();
    }
    if (currentTime >= maxTime) {
        return errCallback && errCallback();
    }
    setTimeout(() => {
        return debounce(expression, ++currentTime, maxTime, callback, errCallback);
    }, 300);
}


/**
 * 检查时间是否有效
 *
 * @export
 * @param {string} startTime
 * @param {string} endTime
 * @param {Date} sysDate 可选
 * @returns
 */
export function checkDateValid(startTime, endTime, sysDate) {
    if (!startTime || !endTime) {
        return false;
    }
    let flag = false;
    if (startTime && endTime) {
        const promStarttime = new Date(startTime.replace(/-/g, '/'));
        const promEndtime = new Date(endTime.replace(/-/g, '/'));
        const now = sysDate || new Date();
        if (now > promStarttime && now < promEndtime) {
            flag = true;
        }
    }
    return flag;
}